import SyListPreview from "./sy-file-list-preview";

export default SyListPreview